import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EnvironmentInjector,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { InflatorComponent } from '../../../../../../inflator/inflator.component';
import { ProductMenu } from '../../../../../../../models/menu/product-menu';

@Component({
  selector: 'app-product-plus-x-more-inflator',
  templateUrl: './product-plus-x-more-inflator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductPlusXMoreInflatorComponent extends InflatorComponent implements OnChanges {
  constructor(
    protected elementRef: ElementRef,
    injector: Injector,
    environmentInjector: EnvironmentInjector
  ) {
    super(injector, environmentInjector);
  }

  @Input() menu: ProductMenu;
  @Input() howManyAdditionalItems: number;
  @Output() sectionHeightInPx = new EventEmitter<number>(true);

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.menu) {
  //     this.connectToComponentType(this.menu.getSectionsPlusXMoreType());
  //   } else {
  //     super.ngOnChanges(changes);
  //   }
  // }
}
